import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import BundleTypeBar from 'components/common/BundleTypeBar';
import Content from 'components/Content';
import BuyButton from 'components/BuyButton';
// import SearchKeywords from 'components/common/SearchKeywords';
import AudioList from './AudioList';
import { Link } from 'react-router-dom';
import { asyncFetchBundle } from 'actions/bundles';
import { priceAudioMegaBundle, priceAudioMegaBundleInit } from 'actions/order';
import * as Const from 'util/constants';
import './AudioBundle.scss';

export class AudioBundle extends Component {
  state = {
    preview: null
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    const { fetchBundle } = this.props;
    fetchBundle(id);
  }

  componentDidUpdate(prevProps, prevState) {
    this.syncTitle();
    this.syncDescription();
    ReactTooltip.rebuild();
  }

  syncTitle() {
    const { bundle } = this.props;
    if (bundle) {
      let title = `Doodly: ${bundle.name}`;
      if (this.state.preview) {
        title += ` - ${this.state.preview.title}`;
      }
      document.title = title;
    }
  }

  syncDescription() {
    const { bundle } = this.props;
    if (bundle) {
      let description = `The ${bundle.name} audio bundle comes complete with ${this.getTags(5, 1).join(
        ', '
      )} and much more.`;

      const descriptionEl = document.querySelector('meta[name="description"]');
      if (descriptionEl) {
        descriptionEl.setAttribute('content', description);
      } else {
        const descriptionEl = document.createElement('meta');
        descriptionEl.setAttribute('name', 'description');
        descriptionEl.setAttribute('content', description);
        document.head.append(descriptionEl);
      }
    }
  }

  getTags(count = 0, per_keyword = 2) {
    const { bundle } = this.props;
    const tags =
      bundle && bundle.assets
        ? Array.from(
            new Set(
              bundle.assets.flatMap(
                asset =>
                  (asset.tags || '')
                    .split('.')
                    .join(',')
                    .split(',')
                    .map(s => s.trim())
                    .slice(0, per_keyword) // get first tag from each asset (to ensure better coverage)
              )
            )
          )
        : [];

    if (count) {
      return tags.slice(0, count);
    } else {
      return tags;
    }
  }

  previewAsset = asset => {
    this.setState({
      preview: asset
    });
  };

  render() {
    const { bundle, query, homeQuery } = this.props;
    const { preview } = this.state;
    // const keywords = this.getTags();
    return (
      <div className="audio-bundle d-flex flex-column">
        <Header className={Const.TYPE_AUDIO_BUNDLES} />
        <Content className={Const.TYPE_AUDIO_BUNDLES}>
          <div className="d-flex justify-content-start">
            <BundleTypeBar className={Const.TYPE_AUDIO_BUNDLES} />
          </div>
          {bundle && (
            <div className="breadcrumbs">
              <Link to={`/home/${homeQuery}`}>Home</Link>
              <span className="sep">&gt;</span>
              {!bundle.is_purchased ? (
                <Link to={`/${Const.TYPE_AUDIO_BUNDLES}/${query}`}>Audios</Link>
              ) : (
                <Link to={`/my-purchases/${Const.TYPE_AUDIO_BUNDLES}`}>My Purchases</Link>
              )}
              <span className="sep">&gt;</span>
              {bundle.name}
            </div>
          )}
          <div className="sheet">
            {bundle ? (
              <>
                <div className="row">
                  <div className="col-lg-6 thumbnails">
                    <AudioList />
                  </div>
                  <div className="col-lg-6 details">
                    <h2>{bundle ? bundle.name : 'Loading...'}</h2>
                    {!bundle.is_purchased && (
                      <div className="d-flex align-items-center buy">
                        <div className="d-flex align-items-start price">
                          ${priceAudioMegaBundle}
                          <span className="init-price">${priceAudioMegaBundleInit}</span>
                        </div>
                        <BuyButton productId={bundle.clickFunnelsProductId} productType="audio" />
                      </div>
                    )}
                    <div className="caption">{preview ? preview.title : ' '}</div>
                    <div className="description">
                      {bundle.description.split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                    <div className="notice d-none d-lg-block">Click any play button on the left to view a sample</div>
                  </div>
                </div>
                {/* {!bundle.is_purchased && (
                  <div className="row">
                    <div className="col-12 related">
                      <h3>Related keywords</h3>
                      <SearchKeywords keywords={keywords} type={Const.TYPE_AUDIO_BUNDLES} />
                    </div>
                  </div>
                )} */}
              </>
            ) : (
              <i className="loading fas fa-spinner fa-spin" />
            )}
          </div>
        </Content>
        <Footer />
        <ReactTooltip effect="solid" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { home, bundles } = state;
  return {
    bundle: bundles.currentBundle,
    query: bundles.searchFor || '', // get the query used in Audio bundles page
    homeQuery: home.searchFor || '' // get the query used in Home page
  };
};

const mapDispatchToProps = dispatch => ({
  fetchBundle: bundleId => dispatch(asyncFetchBundle(bundleId, 'audio'))
});

export default connect(mapStateToProps, mapDispatchToProps)(AudioBundle);
